import { Checkbox, FormControlLabel, Grid, Typography } from "@tiny/components";
import React from "react";
import { FilterItemCheckboxProps } from "./FilterItemCheckbox.types";

function FilterItemCheckbox(props: FilterItemCheckboxProps) {
  const { checked, onChange, label } = props;

  return (
    <Grid item xs={12} md={6}>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={checked}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChange(event.target.checked)
            }
          />
        }
        label={
          <Typography variant="body2" color="grey" tone={900}>
            {label}
          </Typography>
        }
      />
    </Grid>
  );
}

export default FilterItemCheckbox;
